export * from './lib/desktop-feature-autosave.module';
export * from './lib/autosave-settings/autosave-settings.component';
export * from './lib/autosave-simple-selector/autosave-simple-selector.component';
export * from './lib/autosave.service';
